import { render, staticRenderFns } from "./IndivisualAllowancesSettingHRM.vue?vue&type=template&id=6d29e0e5&"
import script from "./IndivisualAllowancesSettingHRM.vue?vue&type=script&lang=js&"
export * from "./IndivisualAllowancesSettingHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports